module.exports = __webpack_public_path__ + "media/music/synth_chords_9-5cf5511c.mp3";